import { render, staticRenderFns } from "./acceptInvitation.vue?vue&type=template&id=009e4d4a"
import script from "./acceptInvitation.vue?vue&type=script&lang=js"
export * from "./acceptInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports